<template>
    <modal @before-open="beforeOpen"
           name="MemberInfoModal"
           transition="nice-modal-fade"
           :min-width="360"
           :min-height="300"
           :pivot-y="0.4"
           :adaptive="true"
           :max-width="600"
           :reset="true"
           :scrollable="true"
           classes="popupcontainer"
           width="60%"
           height="90%">
        <div class="popupcontainer container">
            <div class="btn-close">
                <svg width="14px" height="14px" viewBox="0 0 12 12" xmlSpace="preserve" @click="close()">
                    <line x1="1" y1="11" x2="11" y2="1" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                    <line x1="1" y1="1" x2="11" y2="11" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                </svg>
            </div>
            <div class="modalHeader">
                <h4>
                    회원정보
                </h4>
            </div>
            <div class="container text-center" style="padding: 1em;">
                <img :src="member.profileImage ?  member.profileImage : require('@/assets/img/profile_base.png')" @error="member.profileImage=require('@/assets/img/profile_base.png')" style="width:100px;height: 100px;" class="img-profile rounded-circle rounded mx-auto d-block" ><br>
                <div class="">
                    <h4>{{member.name}} <span class="badge badge-pill badge-secondary" style="font-size:12px">
                        Lv.{{$root.$children[0].getLevelByMinute($auth.user().volunteerMinute) ?
                        ($root.$children[0].getLevelByMinute(member.volunteerMinute) ? $root.$children[0].getLevelByMinute(member.volunteerMinute).level : 0) : 0}}
                    </span> </h4>
                </div>
                <p style="word-break:break-all;">{{member.introduce}}</p>
                <p v-if="authCheck()" class="alert-success" >메모(관리자전용)
                    <textarea class="form-control" v-model="member.memo" @blur="memberModified()">
                    </textarea>
                </p>
            </div>
            <table class="table table-borderless text-center">
                <thead>
                    <tr>
                        <th scope="col">성별/나이</th>
                        <th scope="col">
                            {{member.genderName}}/{{$root.$children[0].getAgeString(member.age)}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="authCheck()" class="alert-success">
                        <td>기부/OT수강</td>
                        <td>
                            {{member.isDonation ? '기부함': '기부내역없음'}} / {{member.isEducatedOT ? '수강함' : '미수강'}}
                        </td>
                    </tr>
                    <tr v-if="authCheck()" class="alert-success">
                        <td>이메일</td>
                        <td>{{member.email}} {{member.isEmailAuthorized ? '(인증)' : '(미인증)'}}</td>
                    </tr>
                    <tr v-if="authCheck()" class="alert-success">
                        <td>핸드폰</td>
                        <td>{{member.phoneNumber}} {{member.isPhoneAuthorized ? '(인증)' : '(미인증)'}} </td>
                    </tr>
                    <tr>
                        <td>특기</td>
                        <td>
                            <div v-if="member.specialities.length > 0">
                                <span v-for="spec in member.specialities">
                                    {{specialities[spec]}}
                                </span>
                            </div>
                            <span v-if="member.specialities.length == 0">없음</span>
                        </td>
                    </tr>
                    <tr>
                        <td>총 봉사시간</td>
                        <td>
                           약 {{parseInt(member.volunteerMinute/60)}}시간
                        </td>
                    </tr>
                    <tr v-if="authCheck()" :class="member.isKaraRegularMember ? 'alert-success' : 'alert-danger'">
                        <td>카라정기회원여부</td>
                        <td>
                            {{member.isKaraRegularMember ? '정기회원' : '비회원'}}
                        </td>
                    </tr>
                    <tr v-if="authCheck()" :class="member.isWithdraw ? 'alert-danger' : 'alert-success'">
                        <td>회원여부</td>
                        <td>
                            {{member.isWithdraw ? '탈퇴' : '회원'}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="modalFooter text-center">
                <h6 role="button" @click="close()">닫기</h6>
            </div>
        </div>
    </modal>
</template>

<script>

    export default {
        name: "MemberInfoModal",

        data() {
            return {
                memberId: 0,
                member : {
                    specialities: [],
                },
                specialities: [],
            }
        },
        methods: {
            close() {
                this.$modal.hide('MemberInfoModal')
            },
            beforeOpen (event) {
                this.member = event.params.member;
            },
            memberModified() {
                let me = this;

                this.axios.put(process.env.VUE_APP_ADMIN_API_URL + `/member`, this.member)
                    .then(function (res) {
                        me.member = res.data;
                    }).catch(function (error) {
                    console.log(error);
                    alert('등록 에러');
                });
            },
            memberWithdraw(){
                if(this.member.isWithdraw)
                    this.memberModified()
            },
            memberAdmin(){
                let me = this;

                this.axios.put(process.env.VUE_APP_ADMIN_API_URL + `/member/${this.member.id}`, this.member)
                    .then(function (res) {
                        me.member = res.data;
                    }).catch(function (error) {
                    console.log(error);
                    alert('등록 에러');
                });
            },
            getSpecialityMap() {
                let me = this;
                this.axios.get(process.env.VUE_APP_MEMBER_API_URL + '/speciality') //JSON.parse(JSON.stringify(this.member))
                    .then(function (res) {
                        me.specialities = res.data;
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },
            authCheck(){
                return this.$auth.check() && this.$auth.user().roleNames.includes('ADMIN')
            }
        },
        mounted() {
            this.getSpecialityMap()
        },
        created() {

        },
    }
</script>

<style scoped>
    .popupcontainer {
        overflow-y: auto;
        border-radius: 5px;
        background: #F7F7F7;
        max-height: 90%;
        max-width: 95%;
        /*max-height: 600px;*/

    }
    .btn-close {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        position: absolute;
        right: 20px;
        top: 5px;
    }
    .btn-close line {
        stroke: grey;
        stroke-width: 2;
    }
    .btn-close:hover line {
        stroke: black;
    }
    .modalHeader {
        border-bottom: 1px solid #EEE;
        padding: 1em;
        text-align: left;
    }
    .modalFooter {
        border-top: 1px solid #EEE;
        padding: 1em;
        text-align: center;
    }
    table {

    }
</style>